// REACT, ROUTER
import React, { useEffect, useRef, useState } from "react";

// COMPONENTS, FUNCTIONS
import useOutsideClick from "../../functions/useOutsideClick";
import {
  CalculatorUnitProps,
  ConverterUnitProps,
  ImportCalculatorsProptype,
  ReceiptUnitProps,
} from "../../interface/propTypesInterface";
import { addAnimation } from "../../functions/animationHandler";

// NPM INSTALLS
import * as FaIcons from "react-icons/fa";

// INTERFACES
import { Receipt } from "../../interface/functionalityInterface";

// ----------------------------------------------------
export default function ImportCalculatorsTool(
  props: ImportCalculatorsProptype
) {
  // :::::: CONSTANTS ::::::
  const elemID = "search-calc-tool"; // If i need to get the element id
  const { importCalcs } = props;
  // ::::: USE STATES ::::::
  const [data, setData] = useState<
    (CalculatorUnitProps | ConverterUnitProps | ReceiptUnitProps)[]
  >([]);
  const [askedConfirm, setaskedConfirm] = useState(false);
  const [show, setshow] = useState(false);

  // ::::: USE HOOKS :::::

  useEffect(() => {
    if (show) {
      document.documentElement.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyPress);
    } else {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    }
    return () => {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [show]);
  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, () => {
    if (!show) return;
    handleExit();
  });

  // ::::: HANDLER FUNCTIONS ::::::

  const handleImport = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const target = e.target as HTMLElement;
    const popupElement = target.parentElement?.parentElement;
    // meTODO MIGHT BE AN ERROR HERE NOT SURE
    if (data.length < 1) {
      if (popupElement) addAnimation(popupElement, "shakeHorErrorCentered");
      return;
    }
    if (!askedConfirm) setaskedConfirm(true);
    // If given confirmation, execute
    if (askedConfirm) {
      importCalcs(data);
      handleExit();
    }
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      handleExit();
    }
  };

  const handleExit = () => {
    setData([]);
    setshow(false);
    setaskedConfirm(false);
    const inputElement = document.getElementById(
      "input-import-data"
    ) as HTMLInputElement;
    inputElement.value = "";
  };

  const handleSelectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const result = event.target?.result as string;
      const obj = JSON.parse(result);
      try {
        setData(obj);
      } catch (err) {
        // meTODO Notification wrong data
      }
    };
    reader.readAsText(e.target.files![0]);
  };

  // ::::: JSX :::::
  return (
    <div className="import-calcs" ref={ref}>
      <button
        onClick={() => setshow(true)}
        className="rectangular-button small translateY"
      >
        <FaIcons.FaDownload />
        <span style={{ marginLeft: ".5rem" }}>Import</span>
      </button>
      <aside
        className={show ? "popup visible center" : "popup center"}
        id="import-calcs-tool"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <button
          className="close-button"
          style={{ position: "absolute", left: "1.5rem", top: "2rem" }}
          type="button"
          onClick={handleExit}
          tabIndex={show ? 0 : -1}
        ></button>
        <h4 style={{ marginBottom: "1rem", textAlign: "center" }}>
          Import data
        </h4>
        <p style={{ textAlign: "center" }}>
          {" "}
          {askedConfirm
            ? "Are you sure? All your work will be replaced!"
            : "Find your json file by clicking the button below"}
        </p>
        <label
          htmlFor="input-import-data"
          className="rectangular-button accent-color"
          style={
            data.length > 0
              ? {
                  borderColor: "var(--color-success)",
                  width: "93%",
                  backgroundSize: "100rem",
                  margin: "0.6rem",
                  color: "var(--color-success",
                  fontWeight: "normal",
                }
              : { width: "93%", backgroundSize: "100rem", margin: "0.6rem" }
          }
          tabIndex={show ? 0 : -1}
        >
          {data.length > 0 ? "File obtained!" : "Click here to upload!"}
        </label>
        <input
          className="custom-input"
          type="file"
          name="import"
          id="input-import-data"
          onChange={(e) => handleSelectFile(e)}
        />
        <div style={{ display: "flex", width: "100%" }}>
          <button
            onClick={handleImport}
            type="button"
            className="rectangular-button accent-color"
            disabled={data.length < 1 ? true : false}
            style={{
              width: "100%",
              backgroundSize: "100rem",
            }}
            tabIndex={show && data.length > 1 ? 0 : -1}
          >
            {askedConfirm ? "I am sure!" : "Start import"}
          </button>
        </div>
      </aside>
    </div>
  );
}
